import React, { useContext } from 'react';
import { ThemeProvider } from 'emotion-theming';
import { Theme, ThemeContext } from '../../utilities/theme';
import { ColorCodes, colorsForTheme } from '../../foundations/color';
import CircleIcon from '../../components/CircleIcon';
import {
  AccountSummaryBlock,
  UserDetailsBlock,
  NameWrapper,
  EmailWrapper,
  CircleIconWrapper,
  SubtextWrapper,
  ActionWrapper,
  LabelContainer,
} from './AccountDropdown.styles';

type Variants = 'basic' | 'default' | 'active';

export type AccountDropdownProps = {
  fullName: string;
  email?: string;
  variant?: Variants;
  action?: string;
  subText?: string;
};

const getTheme = (theme: Theme): themeStyles => {
  const colors = colorsForTheme(theme);
  const colorThemes = {
    nameColor: colors.SPACE,
    emailColor: colors.STORM,
    circleInitialsColor: colors.STEEL,
    subTextColor: colors.STEEL,
    actionTextColor: colors.SWEET_ORANGE,
  };
  return colorThemes;
};

type themeStyles = {
  nameColor: ColorCodes;
  emailColor: ColorCodes;
  circleInitialsColor: ColorCodes;
  subTextColor: ColorCodes;
  actionTextColor: ColorCodes;
};

export const AccountDropdown = (props: AccountDropdownProps) => {
  const { fullName, email, variant = 'basic', action, subText } = props;
  const themeStyle = getTheme(useContext(ThemeContext));
  return (
    <ThemeProvider theme={themeStyle}>
      <AccountSummaryBlock>
        <CircleIconWrapper>
          <CircleIcon size="md" type="text" name={fullName} state={variant} />
        </CircleIconWrapper>
        <UserDetailsBlock>
          <LabelContainer>
            <NameWrapper>{fullName}</NameWrapper>
          </LabelContainer>
          <LabelContainer>
            <EmailWrapper>{email}</EmailWrapper>
          </LabelContainer>
          {action && (
            <LabelContainer>
              <ActionWrapper>{action}</ActionWrapper>
            </LabelContainer>
          )}
          {subText && (
            <LabelContainer>
              <SubtextWrapper>{subText}</SubtextWrapper>
            </LabelContainer>
          )}
        </UserDetailsBlock>
      </AccountSummaryBlock>
    </ThemeProvider>
  );
};

export default AccountDropdown;
